import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "main-wallet__top" }
const _hoisted_3 = { class: "main-wallet__main-info" }
const _hoisted_4 = { class: "main-wallet__icon" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "main-wallet__info" }
const _hoisted_7 = { class: "main-wallet__sum" }
const _hoisted_8 = { class: "main-wallet__wallet" }
const _hoisted_9 = { class: "main-wallet__wallet-address for-copy" }
const _hoisted_10 = { class: "row mt-2 pt" }
const _hoisted_11 = { class: "col-sm-12 d-flex justify-content-between align-items-center pb-0 p-sm" }
const _hoisted_12 = {
  for: "amount",
  class: "col-form-label text-capitalize-first"
}
const _hoisted_13 = { class: "col-sm-12" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "row mt-2 pt" }
const _hoisted_16 = { class: "col-sm-12 d-flex justify-content-between align-items-center pb-0 p-sm" }
const _hoisted_17 = {
  for: "address",
  class: "col-form-label text-capitalize-first"
}
const _hoisted_18 = { class: "col-sm-12" }
const _hoisted_19 = { class: "requisites__controls pt" }
const _hoisted_20 = { class: "text-capitalize-first" }
const _hoisted_21 = { class: "text-capitalize-first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CopyButton = _resolveComponent("CopyButton")!
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_LoaderButton = _resolveComponent("LoaderButton")!
  const _component_WithdrawalWhitelistPopup = _resolveComponent("WithdrawalWhitelistPopup")!
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createBlock(_component_Popup, {
    ref: (el) => _ctx.popup = el,
    title: _ctx.$t('labels.withdrawal'),
    onOnClose: _ctx.hide
  }, {
    default: _withCtx(() => [
      (_ctx.account)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("img", {
                    src: _ctx.helper.currencyIcon(_ctx.account.currency)
                  }, null, 8, _hoisted_5)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.account.sumWithoutInsurance)), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.account.currency), 1)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.account._wallet ? _ctx.truncateAddress(_ctx.account._wallet.address) : ''), 1),
                    _cache[7] || (_cache[7] = _createElementVNode("span", null, "(USDT TRC20)", -1)),
                    _createVNode(_component_CopyButton, {
                      value: _ctx.account._wallet?.address
                    }, null, 8, ["value"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("label", _hoisted_12, [
                  _createTextVNode(_toDisplayString(_ctx.helper.trans("labels.amount")) + " ", 1),
                  _createElementVNode("a", {
                    class: "link",
                    href: "#",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.form.amount = _ctx.numberFormatter.formatNumber(_ctx.availableAmount, _ctx.account.sum.subunit)), ["prevent"]))
                  }, [
                    _createElementVNode("small", null, _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.availableAmount, _ctx.account.sum.subunit)), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_FormInputWrapper, {
                  errors: _ctx.getErrors(`amount`)
                }, {
                  default: _withCtx((parentProps) => [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.amount) = $event)),
                      class: _normalizeClass([parentProps.class, "form-control"]),
                      type: "text",
                      id: "amount"
                    }, null, 2), [
                      [_vModelText, _ctx.form.amount]
                    ])
                  ]),
                  _: 1
                }, 8, ["errors"])
              ]),
              (_ctx.feeAmount > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("small", null, _toDisplayString(_ctx.helper.trans("labels.withdrawal_fee_warning", {fee: _ctx.numberFormatter.formatNumber(_ctx.feeAmount, 2), feeCurrency: 'USDT'})), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.helper.trans("labels.address.usdt")), 1),
                _createElementVNode("a", {
                  class: "link",
                  href: "#",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.showWhitelist()), ["prevent"]))
                }, [
                  _createElementVNode("small", null, _toDisplayString(_ctx.helper.trans("labels.edit_whitelist")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_FormInputWrapper, {
                  errors: _ctx.getErrors(`address`)
                }, {
                  default: _withCtx((parentProps) => [
                    (_ctx.store.getters.getUser?.withdrawalAddress)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.address) = $event)),
                          readonly: "",
                          class: _normalizeClass([parentProps.class, "form-control"]),
                          type: "text",
                          id: "address"
                        }, null, 2)), [
                          [_vModelText, _ctx.form.address]
                        ])
                      : (!_ctx.account.withdrawalWhitelistsEnabled)
                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 1,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.address) = $event)),
                            class: _normalizeClass([parentProps.class, "form-control"]),
                            type: "text",
                            id: "address"
                          }, null, 2)), [
                            [_vModelText, _ctx.form.address]
                          ])
                        : (_openBlock(), _createBlock(_component_Multiselect, {
                            key: 2,
                            class: _normalizeClass([parentProps.class, "multiselect"]),
                            modelValue: _ctx.form.address,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.address) = $event)),
                            options: _ctx.whitelistAddresses,
                            "select-label": "Select",
                            "deselect-label": "",
                            placeholder: "",
                            "open-direction": "bottom",
                            multiple: false,
                            searchable: false,
                            "clear-on-select": false,
                            "close-on-select": true,
                            "show-no-results": false,
                            "hide-selected": false
                          }, null, 8, ["class", "modelValue", "options"]))
                  ]),
                  _: 1
                }, 8, ["errors"])
              ])
            ]),
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.getErrors(``),
              class: "pb"
            }, {
              default: _withCtx((parentProps) => [
                _createElementVNode("span", {
                  class: _normalizeClass(parentProps.class)
                }, null, 2)
              ]),
              _: 1
            }, 8, ["errors"]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("button", {
                class: "btn",
                type: "button",
                onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)), ["prevent"]))
              }, [
                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('button.cancel')), 1)
              ]),
              _createVNode(_component_LoaderButton, {
                "on-click": _ctx.save,
                class: "btn btn--accept"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('button.withdraw')), 1)
                ]),
                _: 1
              }, 8, ["on-click"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_WithdrawalWhitelistPopup, { ref: "withdrawalWhitelistPopup" }, null, 512)
    ]),
    _: 1
  }, 8, ["title", "onOnClose"]))
}